import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AuthenticationService } from "../../auth/service";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import Swal from 'sweetalert2';


@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

	constructor(private authService: AuthenticationService,
		private router: Router,
	) { }

	canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		throw new Error('Method not implemented.');
	}
	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> {
		let user = JSON.parse(localStorage.getItem("currentUser"));

		if (user != null) {
			return this.authService.auth(user.auth, user.email).pipe(
				map((res) => {
					if (!res) {
						this.authService.logout(user.email);
						return this.router.parseUrl('/login'); // Redirecionar para a página de login
					} else {
						return true; // O usuário tem permissão para acessar as rotas filhas
					}
				})
			);
		} else {
			this.router.navigate(['login'])
			Swal.fire({
				title: "Permissão negada",
				text: "Faça o login.",
				icon: "error",
				confirmButtonText: "Confirmar",
				confirmButtonColor: '#161D31',
			}).then(() => {
				this.router.navigate(['login'])
			});
			return of(false);
		}
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
		let user = JSON.parse(localStorage.getItem("currentUser"));
		if (user != null) {
			return of(true);
			// AUTENTICAÇÃO ANTIGA, QUANDO A API NÃO TINHA AUTENTICAÇÃO 
			// return this.authService
			// 	.auth(user.auth, user.email)
			// 	.pipe(
			// 		map((res) => {
			// 			if (!res) {
			// 				this.authService.logout(user.email);
			// 				return false;
			// 			} else {
			// 				return true;
			// 			}
			// 		})
			// 	);
		} else {
			this.router.navigate(['login'])
			Swal.fire({
				title: "Permissão negada",
				text: "Faça o login.",
				icon: "error",
				confirmButtonText: "Confirmar",
				confirmButtonColor: '#161D31',
			}).then(() => {
				this.router.navigate(['login'])
			});
			return of(false);
		}
	}

}